"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNER_DASHBOARD_TEST_PARTNER = exports.MOCK_CK_CUSTOMER_ID = exports.MOCK_CK_AUTH_CODE = void 0;
// These fields are used for mocking the CK Auth flow in playwright tests
// MOCK_CK_CUSTOMER_ID is returned by creditKarmaAuthProvider.exchangeAuthCode when it recieves MOCK_CK_AUTH_CODE
exports.MOCK_CK_AUTH_CODE = 'mock-ck-auth-code';
exports.MOCK_CK_CUSTOMER_ID = 'mock-ck-customer-id';
/**
 * partner_details fields for the partner-dashboard e2e test partner.
 */
exports.PARTNER_DASHBOARD_TEST_PARTNER = {
    name: 'Test Partner',
    supportEmail: 'pwpartnersupport@aven.com',
    landingPage: 'pw-partner-dashboard.aven.com',
};
